import { useState } from "react";
import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { faqs } from "@/mocks/faqs";

export default function FaqPreview() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  const preview = faqs.slice(0, 4);

  return (
    <section className="bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <SectionHeading
              eyebrow="常见问题"
              title="关于妖精漫画图鉴，你想知道的都在这里"
              desc="从什么是韩国妖精漫画，到如何快速查找角色、萌娘属性与CP组合，常见疑问一次说清。"
            />
            <Link
              to="/faq"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              查看全部 FAQ
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>

          <div className="lg:col-span-3">
            <div className="divide-y divide-background-200 rounded-2xl border border-background-200 bg-background-50">
              {preview.map((f, i) => {
                const open = openIdx === i;
                return (
                  <div key={f.q}>
                    <button
                      type="button"
                      onClick={() => setOpenIdx(open ? null : i)}
                      aria-expanded={open}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className="text-sm font-semibold text-foreground-950 md:text-base">{f.q}</span>
                      <span
                        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                          open ? "bg-primary-100 text-primary-600" : "bg-background-100 text-foreground-500"
                        }`}
                      >
                        <i className={`${open ? "ri-subtract-line" : "ri-add-line"} text-base`} aria-hidden="true"></i>
                      </span>
                    </button>
                    {open && (
                      <div className="px-5 pb-5">
                        <p className="text-sm leading-relaxed text-foreground-600">{f.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}